var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "16",
  cy: "17.727",
  r: "2.727"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.93 8.64a2.962 2.962 0 002.086-.844.466.466 0 00-.657-.661l-.003.002a2.128 2.128 0 01-2.86-.009.466.466 0 00-.643.676 3.01 3.01 0 002.077.837zm.028 2.173a4.936 4.936 0 003.5-1.419.464.464 0 00.005-.656l-.004-.004a.472.472 0 00-.664-.001 4 4 0 01-2.837 1.147 4.048 4.048 0 01-2.836-1.146.472.472 0 00-.665 0 .464.464 0 00-.004.655l.004.004a4.997 4.997 0 003.5 1.42zm4.176-.497a5.922 5.922 0 01-8.375.033l-.033-.033a.466.466 0 00-.66.66 6.855 6.855 0 009.695.033l.033-.033a.466.466 0 00-.658-.66z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 2a14.014 14.014 0 00-4.094 27.388c.255.078.518.137.78.2a13.566 13.566 0 006.628 0c.262-.063.525-.122.78-.2A14 14 0 0016 2zm13 14a13.006 13.006 0 01-7 11.521V24.39a3.04 3.04 0 00-3.075-2.843h-5.85A3.04 3.04 0 0010 24.389v3.132A12.98 12.98 0 017.705 6h16.59A12.977 12.977 0 0129 16zm-9.686 12.556v-2.647h.78v2.42c-.256.086-.517.157-.78.227zm-7.408-.227v-2.42h.78v2.647c-.263-.07-.524-.141-.78-.227z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--sound-shower-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'SoundShowerCircleIcon';
export default Icon;